<template>
  <i class="fas scrollup fa-angle-double-up" @click="scrolltopman"></i>
  <!-- {{ hello }} -->
</template>

<script>
export default {
  name: "Scrollup",
  data() {
    return {
      // hello: window.scrollY,
      // displayornot: false,
    };
  },
  // watch() {
  //   // hello(){
  //   //   displayornot=true;
  //   // }
  // },
  methods: {
    scrolltopman() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
.scrollup {
  position: fixed;
  bottom: 20px;
  right: 20px;
  font-size: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 14px;
  padding-right: 14px;
  border-radius: 50%;
  z-index: 2;
  background: #149ddd;
  cursor: pointer;
  animation-name: animate;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  transition: 0.5s;
}
@keyframes animate {
  0%,
  100% {
    color: rgba(255, 255, 255, 0.089);
  }
  20%,
  80% {
    color: rgba(255, 255, 255, 0.507);
  }
  30%,
  60% {
    color: rgba(255, 255, 255, 0.856);
  }
  50% {
    color: white;
  }
}
</style>
